import LogRocket from 'logrocket';

const LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID;

export const initLogRocket = () => {
  LogRocket.init(LOGROCKET_APP_ID, {
    release: import.meta.env.VITE_SENTRY_RELEASE || null,
    shouldDebugLog: false
  });
}